(function (global) {
  'use strict';

  var MERCHANDISING_SELECTOR = '[data-tf-preset-bundle-merchandising]';

  function isPositiveWholeNumber(value) {
    return /^[1-9]\d*$/.test(value);
  }

  function enhanceMerchandising(merchandising, policyApi, policy) {
    var pieceCountText = merchandising.getAttribute('data-piece-count') || '';
    var saving = merchandising.querySelector('[data-tf-preset-bundle-saving]');
    var percentage = merchandising.querySelector('[data-tf-preset-bundle-percentage]');
    var progress;

    if (!saving || !percentage || !isPositiveWholeNumber(pieceCountText) || policy.state !== 'active') {
      return;
    }

    progress = policyApi.resolveProgress(policy, Number(pieceCountText));

    if (!progress.currentTier || typeof progress.currentTier.percentage !== 'number' || !Number.isFinite(progress.currentTier.percentage) || progress.currentTier.percentage <= 0) {
      return;
    }

    percentage.textContent = String(progress.currentTier.percentage);
    saving.hidden = false;

    if (merchandising.hasAttribute('data-tf-featured-set-merchandising')) {
      merchandising.hidden = false;
    }
  }

  function enhanceCards() {
    var policyApi = global.TheFaithMultibuy;
    var policy;
    var merchandisingItems;

    if (!policyApi || typeof policyApi.readPolicy !== 'function' || typeof policyApi.resolveProgress !== 'function' || !global.document) {
      return;
    }

    policy = policyApi.readPolicy();

    if (!policy || policy.state !== 'active') {
      return;
    }

    merchandisingItems = global.document.querySelectorAll(MERCHANDISING_SELECTOR);

    for (var index = 0; index < merchandisingItems.length; index += 1) {
      enhanceMerchandising(merchandisingItems[index], policyApi, policy);
    }
  }

  global.TheFaithPresetBundleCardMerchandising = {
    enhanceCards: enhanceCards
  };

  if (global.document && global.document.readyState === 'loading') {
    global.document.addEventListener('DOMContentLoaded', enhanceCards);
  } else {
    enhanceCards();
  }

  if (global.document) {
    global.document.addEventListener('tf:collection-results-replaced', enhanceCards);
  }
})(typeof window !== 'undefined' ? window : globalThis);
